export var VELT_SDK_VERSION = '5.0.2-beta.32';
export var VELT_SDK_INIT_EVENT = 'onVeltInit';
export var VELT_TAB_ID = 'veltTabId';
// integrity map for the Velt SDK
// Note: generate integrity hashes with: https://www.srihash.org/
export var INTEGRITY_MAP = {
    '5.0.2-beta.32': 'sha384-Uix4VB4Ks9ZB14Pq5VFX2Pc2V1IAiqCRNWkyUsAvfdzG/qhmdyhMP6S8aTBiMkCZ',
};
